document.addEventListener('DOMContentLoaded', () => {
    if(typeof gform !== 'undefined') {  
        gform.addAction('gform_input_change', (elem, formId, fieldId) => {
            // get .gfield parent item of the elem
            const parentField = elem.closest('.gfield');
            if(parentField.classList.contains('populate-products')) {
                // get the selected option text
                const selectedOption = elem.querySelector('option:checked');
                if(selectedOption) {
                    fetch(ajax_global.url, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            action: "get_product_info",
                            nonce: ajax_global.nonce,
                            product_name: selectedOption.value
                        })
                    })
                    .then(response => response.json())
                    .then(r => {
                        if (r.success) {
                            const productInfoDisplay = parentField.querySelector('.gform-product-info-display');
                            if(productInfoDisplay) {
                                productInfoDisplay.remove();
                            }
                            parentField.insertAdjacentHTML('beforeend', r.data.html);
                        } else {
                            const productInfoDisplay = parentField.querySelector('.gform-product-info-display');
                            if(productInfoDisplay) {
                                productInfoDisplay.remove();
                            }
                        }
                    })
                    .catch(error => {
                        console.error('Error:', error);
                    });
                }
            } else {
                const productInfoDisplay = document.querySelector('.gform-product-info-display');
                if(productInfoDisplay) {
                    productInfoDisplay.remove();
                }
            }
        });
    }

    document.addEventListener('gform/post_render', (event) => {
        const formId = event.detail.formId;
        if(formId === 2) {
            // get the product_id and reason from the url
            const productId = new URLSearchParams(window.location.search).get('product_id');
            const reason = new URLSearchParams(window.location.search).get('reason');
            if(productId) {
                fetch(ajax_global.url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: "get_product_info",
                        nonce: ajax_global.nonce,
                        product_id: productId
                    })
                })
                .then(response => response.json())
                .then(r => {
                    if (r.success) {
                        const hiddenField = document.querySelector('#input_2_7');
                        if(hiddenField) {
                            hiddenField.value = r.data.product_name;
                            document.querySelector('.gform_body').insertAdjacentHTML('afterbegin', r.data.html);
                            document.querySelector('.gform-product-info-display').insertAdjacentHTML('beforebegin', '<div class="microtitle color-blue-light">Product Information</div>');
                        }

                        if(reason && reason === 'data-brief') {
                            const messageField = document.querySelector('.gform-body .message-field textarea');
                            if(messageField) {
                                messageField.value = `I am interested in the ${r.data.product_name} and would like to request a data brief.`;
                                messageField.dispatchEvent(new Event('input', { bubbles: true }));
                            }
                        }
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                });
            }
        }
    });
});